import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedMessage, FormattedNumber, FormattedRelative, injectIntl } from 'react-intl';
import "react-toggle/style.css";
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import SideBar from '../common/layout/sidebar.component.jsx';
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx";
import ShopifyAppContext from '../shopify/shopifyappcontext.js';
import ChoosePlan from "./chooseplan.component.jsx";
import "./myAccount.scss";
import ValidateSubscription from './validatesubscription.tsx';

const developmentSite = "quote-machine-test"
const productionSite = "quote-machine"
const typeOfModal = { portal: "portal", hostedPage: "hostedPage" }

class MyAccount extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            cards: [],
            integrations: [],
            dToolsEnabled: false,
            loading: false,
            locale: AppContext.getLocale().languageWithoutRegionCode,
            planTitle: '',
            planDetailsLine1: '',
            planDetailsLine2: '',
            monthlyTotalPrice: '',
            monthlyTotalPriceCurrency: 'CAD',
            priceNote: '',
            customConditionsFilePublicURL: '',
            lastApprovalDate: '',
            formStatus: '',
            creditCardError: '',
            accountLimit: null,
            changePlan: false,
            showError: false,
            loadingBar: false,
            addons: [],
            plans: [],
            subscription: {},
            initialLoading: true,
            isValid: true,
        }

        this.openIntercom = this.openIntercom.bind(this)
        this.openPortal = this.openPortal.bind(this)
        this.changeLoading = this.changeLoading.bind(this)
        this.setIsValid = this.setIsValid.bind(this)
        this.loadInitialSubscription = this.loadInitialSubscription.bind(this)
        this.hasValidChargebeeSubscription = this.hasValidChargebeeSubscription.bind(this)
    }


    componentDidMount() {
        if (!AppContext.getUserLoggedIn().attributes.superUser && GlobalHelper.getShopifyIntegrationOrigin()) {
            ShopifyAppContext.setOrigin(GlobalHelper.getShopifyIntegrationOrigin()).then(() => { })
        }

        SideBar.activateMenu('account')
        const env = AppContext.getOptions().environment
        try {
            Chargebee.getInstance()
        } catch (error) {
            if (env === "prod") {
                Chargebee.init({ site: productionSite });
            } else {
                Chargebee.init({ site: developmentSite });
            }
        }

        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })

    }

    loadInitialSubscription() {
        AppContext.getApiClient().get('/accounts/billing/subscription-details').then(r => {
            if (!r.error) {
                this.setState({ subscription: r.attributes || {} }, () => {
                    this.getAddons()
                    this.getPlans()
                })
            }
        })
    }

    getPlans() {
        AppContext.getApiClient().get('/accounts/billing/plans').then(r => {
            this.setState({
                plans: r.data || [],
                initialLoading: false,
            })
        })
    }

    getAddons() {
        AppContext.getApiClient().get('/accounts/billing/addons').then(r => {
            this.setState({
                addons: r.data || [],
            })
        })
    }

    openIntercom(event) {
        event.preventDefault()
        if (window.Intercom) {
            window.Intercom('show')
        }
    }

    formatPrice(price) {
        return parseFloat(price) / 100
    }

    changeLoading(value) {
        this.setState({ loading: value })
    }

    hasValidChargebeeSubscription() {
        return AppContext.getAccount().attributes.chargebeeSubscriptionId &&
            AppContext.getAccount().attributes.chargebeeCustomerId &&
            Object.keys(this.state.subscription).length > 0
    }

    setIsValid(value) {
        this.setState({ isValid: value })
    }


    openPortal() {
        this.setState({ showError: false })
        let newData = {
            type: typeOfModal.portal
        }
        let chargebeeInstance = Chargebee.getInstance();
        Promise.all([AppContext.getApiClient().post('/accounts/billing/subscription-modals', newData)]).then(res => {
            if (res[0].error) {
                this.setState({ showError: true })
                return
            } else {
                chargebeeInstance.setPortalSession(res[0].attributes)
                let cbPortal = chargebeeInstance.createChargebeePortal();
                cbPortal.open({
                    close() {
                        chargebeeInstance.logout();
                    }
                });
            }
        })
    }

    render() {
        const limit = this.state.accountLimit
        const documentUsage = limit ? limit.attributes.documentUsage : 0
        const documentLimit = limit ? limit.attributes.documentLimit : 0
        const nextPeriodStart = limit ? limit.attributes.nextPeriodStart : null

        if (['disabled'].includes(AppContext.getAccount().attributes.status)) {
            return <div className="ui-has-modules pt-0">
                    <div>
                        <div className="row ui-title-bar custom-lead justify-content-center pt-3">
                            <h1 className={'text-center'}>
                                <FormattedMessage
                                    id="myaccount.subscription.account_disabled"
                                    defaultMessage="Your account appears to be disabled. For assistance, please contact us using the button below."
                                />
                            </h1>
                        </div>
                            <div className="text-center">
                                <button className={'mt-2 btn-lg btn-primary'} onClick={this.openIntercom}>
                                    <FormattedMessage
                                        id="myaccount.subscription.contact_sales_btn"
                                        defaultMessage="Contact sales"
                                    />
                                </button>
                            </div>
                    </div>
            </div>
        }

        if (['expired', 'churned', 'trial'].includes(AppContext.getAccount().attributes.status) || this.state.changePlan) {
            return <div className="ui-has-modules pt-0">
                <MyAccountTabs />
                <ValidateSubscription
                    loading={this.state.loading}
                    initialLoading={this.state.initialLoading}
                    setIsValid={this.setIsValid}
                    changeLoading={this.changeLoading}
                    loadInitialSubscription={this.loadInitialSubscription}
                    isTrial={false}
                >
                    <div>
                        <div className="row ui-title-bar custom-lead justify-content-center pt-3">
                            <h1 className={'text-center'}>
                                <FormattedMessage
                                    id="myaccount.subscription.choose_your_subscription"
                                    defaultMessage="Choose Your Subscription"
                                />
                            </h1>
                        </div>
                        {this.hasValidChargebeeSubscription() || this.state.loading == true ?
                            <ChoosePlan
                                update={true}
                                addons={this.state.addons}
                                isValid={this.state.isValid}
                                plans={this.state.plans}
                                currency={this.state.plans.length > 0 ? this.state.plans[0].attributes.currency : 'USD'}
                                subscription={this.state.subscription}
                                onFinishLoading={this.changeLoading}
                            />
                            :
                            (<div className="text-center">
                                <button className={'mt-2 btn-lg btn-primary'} onClick={this.openIntercom}>
                                    <FormattedMessage
                                        id="myaccount.subscription.contact_sales_btn"
                                        defaultMessage="Contact sales"
                                    />
                                </button>
                            </div>)}
                    </div>
                </ValidateSubscription>
            </div>
        }


        let progress = documentLimit > 0 ? documentUsage / documentLimit * 100 : 0
        let overBy = documentLimit > 0 ? documentUsage - documentLimit : 0
        if (progress > 100) {
            progress = 100
        }
        let selectedPlan = this.state.plans.find(p => p.id == this.state.subscription.planId)
        let selectedAddons = this.state.subscription.addons && this.state.subscription.addons.length > 0 ?
            this.state.addons.filter(a => this.state.subscription.addons.includes(a.id)) : []

        return <ValidateSubscription
            initialLoading={this.state.initialLoading}
            loading={this.state.loading}
            setIsValid={this.setIsValid}
            changeLoading={this.changeLoading}
            loadInitialSubscription={this.loadInitialSubscription}
            isTrial={false}
        >
            <div className="ui-has-modules pt-0">
                <MyAccountTabs />
                {this.hasValidChargebeeSubscription() && selectedPlan &&
                    <div>
                        <div className="row ui-title-bar custom-lead pt-3 justify-content-lg-center">
                            <h2>
                                <FormattedMessage
                                    id="myaccount.subscription.status"
                                    defaultMessage="Account Status"
                                />
                            </h2>
                        </div>
                        <div className="row justify-content-lg-center">
                            <div className={'col-12 col-lg-6'}>
                                <div className="alert alert-success strong" role="alert">
                                    <FormattedMessage
                                        id="myaccount.subscription.account_active"
                                        defaultMessage="Your account is active!"
                                    />
                                </div>
                            </div>
                        </div>
                        {documentLimit > 0 && <div className="row justify-content-lg-center">
                            <div className={'col-12 col-lg-6'}>
                                <div className={'w-100 d-flex justify-content-between'}>
                                    <strong>
                                        <FormattedMessage
                                            id="myaccount.subscription.document_usage"
                                            defaultMessage="Documents usage ({usage})"
                                            values={{
                                                usage: documentUsage
                                            }}
                                        />
                                    </strong>
                                    <small >
                                        <FormattedMessage
                                            id="myaccount.subscription.next_period_start"
                                            defaultMessage="Next period starts {days}"
                                            values={{
                                                days: <FormattedRelative value={new Date(nextPeriodStart)} />
                                            }}
                                        />
                                    </small>
                                </div>
                                <div className="progress">
                                    <div className={"progress-bar " + (overBy > 0 ? 'bg-danger' : 'bg-success')} role="progressbar" style={{
                                        width: `${progress}%`
                                    }}
                                        aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" />
                                </div>
                                <div className={'row w-100 m-0'}>
                                    <div className={'col-6 p-0'}>
                                        0
                                    </div>
                                    <div className={'col-6 p-0 text-right'}>
                                        <p className={'mb-0'}>{documentLimit}</p>
                                    </div>

                                    {overBy > 0 && <p className={'col-12 p-0 text-right mb-0 text-danger strong'}>
                                        <Icon value={'exclamation-triangle'} className={'mr-1'} />
                                        <FormattedMessage
                                            id="myaccount.subscription.over_by"
                                            defaultMessage="Over by {nb} documents"
                                            values={{
                                                nb: overBy
                                            }}
                                        />
                                    </p>}
                                </div>
                            </div>
                        </div>}


                        <div className="row ui-title-bar custom-lead justify-content-lg-center">
                            <h2>
                                <FormattedMessage
                                    id="myaccount.subscription.show_subscription_info"
                                    defaultMessage="Subscription Details"
                                />
                            </h2>
                        </div>
                    </div>}
                {this.hasValidChargebeeSubscription() && selectedPlan && this.state.isValid &&
                    <div className={'row col-12 justify-content-lg-center m-0 p-0'}>
                        <div className="col-lg-6 ui-module">
                            {selectedPlan &&
                                <div className="flex flex-row">
                                    <h6>
                                        <div className="d-inline-flex">
                                            <div className="font-weight-bold d-inline-flex mr-2">
                                                <u>
                                                    <FormattedMessage
                                                        id="myaccount.subscription.plan_name"
                                                        defaultMessage="Plan:"
                                                    />
                                                </u>
                                            </div>
                                            <div className="mr-2">
                                                {AppContext.getAccount().attributes.defaultLanguage.includes("en") ?
                                                    selectedPlan.attributes.nameEnglish :
                                                    selectedPlan.attributes.nameFrench}
                                            </div>
                                        </div>
                                    </h6>
                                </div>
                            }
                            {selectedAddons && selectedAddons.length > 0 && this.state.isValid &&
                                <div className="flex flex-row">
                                    <h6>
                                        <div className="d-inline-flex">
                                            <div className="font-weight-bold d-inline-flex mr-2">
                                                <u>
                                                    <FormattedMessage
                                                        id="myaccount.subscription.addons_name"
                                                        defaultMessage="Addons:"
                                                    />
                                                </u>
                                            </div>
                                            <div className="mr-2">
                                                {AppContext.getAccount().attributes.defaultLanguage.includes("en") ?
                                                    selectedAddons.map(a => a.attributes.nameEnglish).reduce((prev, curr) => [prev, ', ', curr]) :
                                                    selectedAddons.map(a => a.attributes.nameFrench).reduce((prev, curr) => [prev, ', ', curr])
                                                }
                                            </div>
                                        </div>
                                    </h6>
                                </div>
                            }

                            {selectedPlan && !this.state.subscription.isChildrenAccount && this.state.isValid &&
                                <div className="flex flex-row">
                                    <h6>
                                        <div className="d-inline-flex">
                                            <div className="font-weight-bold d-inline-flex mr-2">
                                                <u>
                                                    <FormattedMessage
                                                        id="myaccount.subscription.plan_total_price"
                                                        defaultMessage="Monthly Payment:"
                                                    />
                                                </u>
                                            </div>
                                            <div className="mr-2">
                                                <FormattedNumber
                                                    style="currency"
                                                    currency={this.state.subscription.currency}
                                                    value={this.formatPrice(this.state.subscription.totalPrice)}
                                                />
                                            </div>
                                        </div>
                                    </h6>
                                </div>
                            }

                            {selectedPlan && this.state.isValid &&
                                <div className="flex flex-row">
                                    <h6 className="border-bottom-0 mb-0">
                                        <div className="d-inline-flex">
                                            <div className="font-weight-bold d-inline-flex mr-2">
                                                <u>
                                                    <FormattedMessage
                                                        id="myaccount.subscription.locations_number"
                                                        defaultMessage="Number of Locations:"
                                                    />
                                                </u>
                                            </div>
                                            {this.state.subscription.planQuantity == 0 ?
                                                <FormattedMessage
                                                    id="myaccount.choose_plan.unlimited"
                                                    defaultMessage="Unlimited"
                                                /> : AppContext.getAccount().attributes.maxNumberOfLocations}
                                        </div>
                                    </h6>
                                </div>}

                            {selectedPlan && this.state.isValid &&
                                <div className="flex flex-row mt-2">
                                    <h6 className="border-bottom-0 mb-0">
                                        <div className="d-inline-flex">
                                            <div className="font-weight-bold d-inline-flex mr-2">
                                                <u>
                                                    <FormattedMessage
                                                        id="myaccount.subscription.users_number"
                                                        defaultMessage="Number of Users:"
                                                    />
                                                </u>
                                            </div>

                                            {AppContext.getAccount().attributes.maxNumberOfUsers == 0 ?
                                                <FormattedMessage
                                                    id="myaccount.choose_plan.unlimited"
                                                    defaultMessage="Unlimited"
                                                /> :
                                                AppContext.getAccount().attributes.maxNumberOfUsers}
                                        </div>
                                    </h6>
                                </div>}
                        </div>
                    </div>

                }

                {!this.state.subscription.isChildrenAccount &&
                    <div className="d-flex flex-row justify-content-lg-center">
                        <div className="mr-2">

                            <button className={'mt-2 btn btn-primary'} onClick={e => {
                                e.preventDefault()
                                this.setState({ changePlan: true })
                            }}>
                                <FormattedMessage
                                    id="myaccount.subscription.change_plan_btn"
                                    defaultMessage="Change plan"
                                />
                            </button>
                        </div>



                        <div>
                            {this.state.isValid && this.hasValidChargebeeSubscription() && <button onClick={this.openPortal} className="mt-2 btn btn-primary">
                                <FormattedMessage
                                    id="myaccount.subscription.billing_details"
                                    defaultMessage="Billing Details"
                                />
                            </button>}
                        </div>
                    </div>
                }
                {(this.state.showError || !this.state.isValid) &&
                    <div className="mt-3 alert alert-danger " role="alert">
                        <FormattedMessage
                            id="myaccount.subscription.manage_subscription_panel"
                            defaultMessage="Contact Support. Manage subscription panel not available."
                        />
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>}

            </div>
        </ValidateSubscription>

    }
}



export default injectIntl(MyAccount);



// WEBPACK FOOTER //
// ./src/my-account/myAccount.component.jsx